var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "widM txtC marTML" }, [
        _c(
          "a",
          {
            staticClass: "disIb fntH5 bold NCACroa_arrow",
            staticStyle: { background: "#20893d", color: "#fff" },
            on: { click: _vm.openActivityPopup }
          },
          [
            _vm._v("\n      액티비티 정보 안내  \n      "),
            _c("img", {
              staticStyle: {
                "max-width": "10px",
                width: "2%",
                "vertical-align": "baseline"
              },
              attrs: {
                src: require("@/views/survey/images/NCACroatia_arrow.png"),
                alt: ""
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "p",
          {
            staticClass: "fntE txtL marTSM",
            staticStyle: { color: "#d91734" }
          },
          [
            _vm._v(
              "* 액티비티 별 잔여인원은 제출 시간에 따라 차이가 있을 수 있습니다."
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("hr", {
        staticClass: "marTML",
        staticStyle: { "border-top": "1px solid #ddd" }
      }),
      _vm._v(" "),
      _vm._l(_vm.activities, function(activity, sq_code, i) {
        return [
          _c("SurveyActivity", {
            key: "activity_" + sq_code,
            attrs: { activity: activity, seq: i }
          }),
          _vm._v(" "),
          i < _vm.activityCount - 1
            ? _c("hr", {
                key: "hr_" + activity.sq_code,
                staticStyle: {
                  "border-top": "1px solid #ddd",
                  background: "#f4f4f4",
                  padding: "5px 0"
                }
              })
            : _vm._e()
        ]
      })
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "marTML",
        staticStyle: { background: "#f4f4f4", "border-top": "2px solid #ddd" }
      },
      [
        _c(
          "div",
          {
            staticClass: "widM fntH4 bold padTS padBS",
            staticStyle: { color: "#2c2c2c" }
          },
          [_vm._v("액티비티 예약")]
        )
      ]
    )
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a6f63b6", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a6f63b6","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/survey/components/SurveyActivityList.vue
// module id = null
// module chunks = 